<template>
    <div class="operator-bar-wrapper clr">
        <div class="operator-box">
            <div class="opeat-l time-box">
                <SingleCalendar @dateSelect="setDateStart" class="time-start" :config="calendarConfig" :value="customDate.startTime" />
                <span class="span-fgf"></span>
                <SingleCalendar @dateSelect="setDateEnd" class="time-end" :config="calendarConfig" :value="customDate.endTime" />
            </div>
            <div class="opeat-r">
                <LangSelect value="all" class="language-select" @change="languageChange" :requireAll="true"></LangSelect>
                <Select initValue="all" :options="senistiveWordOptions" class="senisitive-select" @menuClick="senisitiveWordChange" />
                <ChannelSelect class="channel-select" value="all" @change="channelChange" />
                <Select initValue="all" :options="quesTypeOptions" class="question-type-select" @menuClick="quesTypeChange" />
                <Select initValue="all" :options="answerOptions" class="answer-select" @menuClick="askAnswerChange" />
                <Search :hasInput="true" :placeholder="inputLabel" class="question-search" @searchChange="searchChange" @inputChange="searchChange">
                    <Select
                        :initValue="searchTypeValue"
                        :options="questionOptions"
                        class="question-select"
                        slot="right"
                        @menuClick="searchTypeChange"
                        :topOrBottom="40"
                    />
                </Search>
            </div>
        </div>
    </div>
</template>

<script>
import Search from "@/views/zhiji/bComponents/inputs/Search";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import ChannelSelect from "@/views/zhiji/components/channelSelect/index";
import SingleCalendar from "@/views/zhiji/bComponents/calendar/SingleCalendar";
import LangSelect from "@/components/langSelect";

import { questionTypeOptions } from "@/views/zhiji/components/pagesPanel/pagesConfig.js";
import { answerOptions, questionOptions, senistiveWordOptions } from "../askAnswerLogConfig.js";
import { debounce } from "@/views/zhiji/js/common/util.js";

export default {
    name: "LogOperationBar",
    props: ["data", "row"],
    components: {
        Search,
        Select,
        SingleCalendar,
        ChannelSelect,
        LangSelect
    },
    data() {
        return {
            calendarConfig: {
                position: "left",
                hasRadius: true,
                dateFormat: "YYYY/MM/DD hh:mm"
            },
            customDate: {
                startTime: new Date(this.zhiji.dateFormat(new Date(), "YYYY-MM-DD 00:00")),
                endTime: new Date()
            },
            languageValue: "",
            senWordValue: "",
            channelValue: "",
            quesTypeValue: "",
            answerTypeValue: "",
            searchTypeValue: "all",
            keyWord: "",
            curPage: 1,
            curPageLen: 10
        };
    },
    computed: {
        quesTypeOptions() {
            return questionTypeOptions();
        },
        answerOptions() {
            return answerOptions();
        },
        questionOptions() {
            return questionOptions();
        },
        senistiveWordOptions() {
            return senistiveWordOptions();
        },
        inputLabel() {
            return this.$t("zhiji.common.inputHolderLabel");
        }
    },
    mounted() {
        this.queryHanlder = debounce(() => {
            this.updateLogParams();
        }, 500);
    },
    methods: {
        languageChange(data) {
            data == "all" ? (this.languageValue = "") : (this.languageValue = data);
            this.updateLogParams();
        },
        senisitiveWordChange(data) {
            data.value == "all" ? (this.senWordValue = "") : (this.senWordValue = data.value);
            this.updateLogParams();
        },
        searchChange(data) {
            this.keyWord = data.value;
            this.queryHanlder();
        },
        channelChange(data) {
            data == "all" ? (this.channelValue = "") : (this.channelValue = data);
            this.updateLogParams();
        },
        quesTypeChange(data) {
            data.value == "all" ? (this.quesTypeValue = "") : (this.quesTypeValue = data.value);
            this.updateLogParams();
        },
        askAnswerChange(data) {
            const answerObj = { noAnswer: "0", hasAnswer: "1", all: "" };
            this.answerTypeValue = answerObj[data.value];
            this.updateLogParams();
        },
        searchTypeChange(data) {
            this.searchTypeValue = data.value;
            this.$emit("updateSearchType", this.searchTypeValue);
        },
        setDateStart(date) {
            this.customDate.startTime = new Date(this.zhiji.dateFormat(date));
            this.updateLogParams();
            this.$emit("updateTime", {
                type: "start",
                value: this.zhiji.dateFormat(date)
            });
        },
        setDateEnd(date) {
            this.customDate.endTime = new Date(this.zhiji.dateFormat(date));
            this.updateLogParams();
            this.$emit("updateTime", {
                type: "end",
                value: this.zhiji.dateFormat(date)
            });
        },
        updateLogParams() {
            let reqData = {
                startDate: this.zhiji.dateFormat(this.customDate.startTime),
                endDate: this.zhiji.dateFormat(this.customDate.endTime),
                curPage: this.curPage,
                size: this.curPageLen,
                channel: this.channelValue,
                questionType: this.quesTypeValue,
                answerType: this.answerTypeValue,
                searchType: this.searchTypeValue,
                keyWord: this.keyWord,
                lang: this.languageValue,
                senWords: this.senWordValue
            };
            this.$emit("updateLogData", reqData);
        }
    }
};
</script>

<style lang="scss" scoped>
.operator-bar-wrapper {
    .operator-box {
        padding: 16px 0 6px 0;

        .time-box {
            margin: 0;
            display: inline-block;

            .span-fgf {
                display: inline-block;
                vertical-align: middle;
                background: #e1eaf2;
                width: 12px;
                height: 2px;
                margin: 0 4px;
                position: relative;
                top: -5px;
            }

            .time-start,
            .time-end {
                width: 171px;
                height: 32px;
                margin-bottom: 10px;
                display: inline-block;
            }
        }
    }

    .opeat-l,
    .select-opt,
    .opeat-r {
        display: inline-block;
    }

    .opeat-l {
        margin-top: 6px;
    }

    .opeat-r {
        float: right;
    }

    .senisitive-select,
    .language-select,
    .question-type-select,
    .answer-select,
    .question-search,
    .channel-select {
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 10px;
    }
    .channel-select {
        width: 140px;
        margin-right: 8px;
    }
    .senisitive-select {
        width: 140px;
    }
    .question-select {
        border: 0;
        border-right: 1px solid #e3e3e3;
        border-radius: 0;
    }

    .question-search {
        font-size: 14px;
        width: 318px;
        display: inline-flex;
    }

    .language-select {
        width: 120px;
        margin-right: 8px;
    }
}
.clr {
    &:after {
        content: " ";
        clear: both;
        height: 0;
        visibility: hidden;
        display: block;
    }
}
</style>
